var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Controller, FormProvider, } from 'react-hook-form';
import { TextField } from '@one-thd/sui-atomic-components';
import { getTextFieldStatus } from '../../utils/form';
export var UserFormFields = function (_a) {
    var formMethods = _a.formMethods, onSubmit = _a.onSubmit, isEditMode = _a.isEditMode, children = _a.children;
    var handleSubmit = formMethods.handleSubmit, formErrors = formMethods.formState.errors, control = formMethods.control;
    return (React.createElement(FormProvider, __assign({}, formMethods),
        React.createElement("form", { onSubmit: handleSubmit(onSubmit) },
            React.createElement("div", { className: "md:sui-w-1/2" },
                React.createElement(Controller, { name: "role", control: control, render: function (_a) {
                        var field = _a.field;
                        var ref = field.ref, value = field.value, name = field.name, onChange = field.onChange;
                        return (React.createElement("input", { ref: ref, type: "hidden", id: "role", name: name, value: value || undefined, onChange: onChange, "data-testid": "role-inpt" }));
                    } }),
                React.createElement("div", { className: "sui-pb-4" },
                    React.createElement(Controller, { name: "email", control: control, render: function (_a) {
                            var _b;
                            var field = _a.field;
                            var ref = field.ref, value = field.value, name = field.name, onChange = field.onChange, rest = __rest(field, ["ref", "value", "name", "onChange"]);
                            return (React.createElement(TextField, { fullWidth: true, label: "Email", id: "email", placeholder: "Email", name: name, value: value, onChange: onChange, disabled: isEditMode, status: getTextFieldStatus(formErrors.email), statusMessage: (_b = formErrors.email) === null || _b === void 0 ? void 0 : _b.message, InputProps: {
                                    inputProps: __assign(__assign({}, rest), { 'data-testid': 'email-inpt' }),
                                } }));
                        } })),
                React.createElement("div", { className: "sui-pb-4" },
                    React.createElement(Controller, { name: "firstName", control: control, render: function (_a) {
                            var _b;
                            var field = _a.field;
                            var ref = field.ref, value = field.value, name = field.name, onChange = field.onChange, rest = __rest(field, ["ref", "value", "name", "onChange"]);
                            return (React.createElement(TextField, { fullWidth: true, label: "First Name", id: "firstName", placeholder: "First Name", disabled: isEditMode, status: getTextFieldStatus(formErrors.firstName), statusMessage: (_b = formErrors.firstName) === null || _b === void 0 ? void 0 : _b.message, value: value, name: name, onChange: onChange, InputProps: {
                                    inputProps: __assign(__assign({}, rest), { 'data-testid': 'first-name-inpt' }),
                                } }));
                        } })),
                React.createElement("div", { className: "sui-pb-4" },
                    React.createElement(Controller, { name: "lastName", control: control, render: function (_a) {
                            var _b;
                            var field = _a.field;
                            var ref = field.ref, value = field.value, name = field.name, onChange = field.onChange, rest = __rest(field, ["ref", "value", "name", "onChange"]);
                            return (React.createElement(TextField, { fullWidth: true, label: "Last Name", id: "lastName", placeholder: "Last Name", disabled: isEditMode, status: getTextFieldStatus(formErrors.lastName), statusMessage: (_b = formErrors.lastName) === null || _b === void 0 ? void 0 : _b.message, value: value, name: name, onChange: onChange, InputProps: {
                                    inputProps: __assign(__assign({}, rest), { 'data-testid': 'last-name-inpt' }),
                                } }));
                        } }))),
            children)));
};
